/* 
ALL pages have an expanded different photo - same like header below the nav bar
    Make long text boxes shorter (less width)
*/

import styled from 'styled-components';

export const Err404Section = styled.div`
    display: flex,
    justify-content: center;
    flex-wrap: wrap;
    text-align: center;
    width: 100%;
`
export const Err404H1 = styled.h1`
    margin: 30px;
    width: 65%;
`

export const Err404Belly = styled.img`
    width: 20%;
    margin: 30px;
`

export const Err404p = styled.p`
    width: 100%;
    font-size: 2.2rem;
    margin: 0.5% 0;
`

export const Err404TextDiv = styled.div`
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
`

export const Err404Button = styled.button`
    width: 150px;
    padding: 0.5%;
    margin: 1% 0;
`